import React, {useState, useEffect, useContext} from 'react';
import axios from '../../../config/axios';
import parser from 'react-html-parser';

import AuthContext  from '../../../contexts/AuthContext';

import Button from '../Button/Button';

import classes from './Modal.module.scss';

const Modal = props => {
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true);
    const auth = useContext(AuthContext)[0];

    useEffect(() => {
        if (props.fetch) {
            axios.get(`/${props.fetch}.json?auth=${auth.token}`)
                .then(result => {
                    const fetchedData = Object.keys(result.data)
                        .map(key => ({
                            content: result.data[key].content,
                            date: result.data[key].date
                        }))
                        setData(fetchedData[0]);
                        setLoading(false)
                })
                .catch(error => {
                    setLoading(false);
                })
        }
    })

    return <div className={classes.Modal}>
        <div className={classes.Title}>{props.title}</div>
        <div className={classes.Body}>
            <p>{!props.fetch ? props.content : parser(data.content)}</p>
        </div>
        <div className={classes.Buttons}>
            <Button type='default' clicked={props.onModalClose}>{props.cancelLabel}</Button>
            {props.furtherAction && <Button type='default' clicked={props.furtherAction}>{props.acceptLabel}</Button>}
        </div>
    </div>
}

export default Modal;